import {apiGetRouter} from "@/api/common/auth.js";
import dynamicRoutes from "@/router/dynamic.js";

const modules = import.meta.glob('/src/views/**/*.vue')
const useRoutesStore = defineStore(
    'routes',
    {
        state: () => ({
            routes: [],
            timestamp: 0
        }),
        actions: {
            async getRoutes() {
                try {
                    const {data,timestamp} = await apiGetRouter();
                    data.push(...dynamicRoutes)
                    this.timestamp = timestamp
                    data.push({
                        path: '/:pathMatch(.*)*',
                        redirect: '/404',
                        name: 'Any',
                        meta: {
                            title: '404',
                            hidden: true
                        }
                    });
                    const accessRoutes = convertRouter(data);
                    this.routes = accessRoutes;
                    return accessRoutes;
                } catch (error) {
                    console.error('Error getting routes:', error);
                    throw error;
                }
            }
        }
    })

// 渲染后端返回路由
function convertRouter(asyncRoutes) {
    return asyncRoutes.map((route) => {
        if (route.component && typeof route.component === 'string' ) {
            if (route.component === 'Layout') {
                route.component = () => import('@/layout/index.vue');
            } else {
                route.component = modules[`/src/views${route.component}.vue`];
            }
        }
        if (route.children && route.children.length) {
            route.children = convertRouter(route.children)
        }
        if (route.children && route.children.length === 0) {
            delete route.children
        }
        return route
    })
}

export default useRoutesStore